import { Col, Row } from "reactstrap";
import { SpanAndParagraphTitle } from "../../../Constants/Constants";

const SpanAndParagraph = () => {
  return (
    <section className="element-span-prag">
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{SpanAndParagraphTitle}</h2>
            </div>
            <div className="element-card-body typography">
              <span className="small_prag">This is span</span>
              <p>I would suggest you discuss this further with the advertising team..</p>
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default SpanAndParagraph;
